import { useMutation } from 'react-query'

import {
  createUmbrellaUserInvitation,
  UmbrellaUserInvitationPayload,
} from '@modules-deprecated/app/umbrellas/query-api'

import { APIError } from '../../../../../utils'

interface UseInviteUmbrellaUserProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface InvitedUmbrellaUserPayload {
  umbrellaId: string
  payload: UmbrellaUserInvitationPayload
}

export const useInviteUmbrellaUser = (props?: UseInviteUmbrellaUserProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: inviteUmbrellaUser, isLoading: isProcessing } = useMutation(
    ({ umbrellaId, payload }: InvitedUmbrellaUserPayload) => createUmbrellaUserInvitation(umbrellaId, payload),
    {
      onError,
      onSuccess,
    },
  )

  return {
    isProcessing,
    inviteUmbrellaUser,
  }
}
